import React from 'react';
import { Helmet } from 'react-helmet-async';
import Contact from '../components/Contact';

function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Playfair</title>
        <meta name="description" content="Get in touch with the Playfair team." />
        <link rel="canonical" href="https://playfair.online/contact" />
      </Helmet>
      <Contact />
    </>
  );
}

export default ContactPage;
